(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list/assets/javascripts/game.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list/assets/javascripts/game.js');

'use strict';

const resolveProductId = svs.utils.products.resolveProductId;
const clx = svs.components.lbUtils.clx;
const ReactIcon = svs.ui.ReactIcon;
const FavoriteBadge = svs.components.marketplace.gameList.FavoriteBadge;
const gameHelpers = svs.components.marketplace.helpers.games;
const GameTypeTag = svs.components.marketplace.gameTypeTag.GameTypeTag;
const RibbonBanner = svs.ui.ReactRibbon.RibbonBanner;
const MarketplaceBrand = svs.components.marketplace.marketplaceBrand.MarketplaceBrand;
const getStatusDesc = svs.components.marketplace.helpers.games.getStatusDesc;
const format = svs.utils.format;
const showFewSharesLeftRibbon = svs.components.marketplace.helpers.games.showFewSharesLeftRibbon;
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const Game = _ref => {
  let children = _ref.children,
    className = _ref.className,
    game = _ref.game,
    groupId = _ref.groupId,
    isRetail = _ref.isRetail,
    LinkComponent = _ref.LinkComponent,
    productName = _ref.productName,
    _ref$shouldScrollTo = _ref.shouldScrollTo,
    shouldScrollTo = _ref$shouldScrollTo === void 0 ? false : _ref$shouldScrollTo;
  const activatedDrawId = game.activatedDrawId,
    fractionPrice = game.fractionPrice,
    gameStatus = game.status,
    isAllowedToSubmit = game.isAllowedToSubmit,
    isFavorite = game.isFavorite,
    name = game.name,
    preliminaryRowExists = game.preliminaryRowExists,
    soldShares = game.soldShares,
    subProductId = game.subProductId;
  const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);
  const productId = resolveProductId(productName);
  const gameTag = gameHelpers.getSubProductTag(productId, subProductId);
  const showGameTag = gameTag && isRetail;
  const el = useRef();
  const showFewSharesLeft = showFewSharesLeftRibbon(game, groupId);
  const classNames = clx('game-container', className, {
    'few-shares-left': showFewSharesLeft
  });
  const gameStatusDesc = getStatusDesc(gameStatus, isAllowedToSubmit, preliminaryRowExists);
  const WrapContentWithLink = _ref2 => {
    let children = _ref2.children;
    if (LinkComponent) {
      return React.createElement(LinkComponent, null, React.createElement("div", {
        "aria-hidden": "true",
        className: classNames,
        "data-testid": "qa-game"
      }, children));
    }
    return React.createElement("div", {
      "aria-hidden": "true",
      className: classNames,
      "data-testid": "qa-game"
    }, children);
  };
  useEffect(() => {
    if (shouldScrollTo) {
      svs.components.Storage.browser.get('lastClickedGame', 'marketplace', data => {
        if (data && data.activatedDrawId && data.activatedDrawId === activatedDrawId && el.current) {
          el.current.scrollIntoView({
            behavior: 'instant',
            block: 'center'
          });
          svs.components.Storage.browser.set('lastClickedGame', 'marketplace', null);
        }
      });
    }
  }, []);
  return React.createElement(WrapContentWithLink, null, isFavorite && React.createElement(FavoriteBadge, null), React.createElement("div", {
    className: "game-wrapper ".concat(showGameTag ? 'game-type-tag-height' : '')
  }, showFewSharesLeft && React.createElement(RibbonBanner, {
    direction: "right",
    size: "200"
  }, "F\xE5 andelar kvar!"), React.createElement("div", {
    className: "game-container-brand"
  }, React.createElement("i", {
    className: "game-icon"
  }, React.createElement(MarketplaceBrand, {
    productId: productId,
    square: true,
    subProductId: subProductId || null
  }))), React.createElement("div", {
    className: "game-status"
  }, showGameTag && React.createElement(GameTypeTag, {
    productId: productId,
    subProductId: subProductId
  }), React.createElement("div", {
    className: "f-medium f-600"
  }, React.createElement("div", {
    className: "game-title".concat(showFewSharesLeft ? '-shortened' : ''),
    ref: el
  }, name ? capitalizeFirstLetter(name) : '-'), preliminaryRowExists && React.createElement("div", {
    className: "preliminary-row-icon"
  }, React.createElement(ReactIcon, {
    icon: "overview",
    size: "100"
  }))), children)), React.createElement("div", {
    className: "game-status-desc-container"
  }, React.createElement("div", {
    className: "game-status-desc"
  }, isAllowedToSubmit && React.createElement("div", {
    className: "game-status-fractions"
  }, "Laget har ".concat(format.Currency(fractionPrice * soldShares), " kr att spela f\xF6r")), gameStatusDesc && React.createElement("div", {
    className: "fc-red",
    "data-testid": "qa-game-status-text"
  }, gameStatusDesc))));
};
setGlobal('svs.components.marketplace.gameList.Game', Game);

 })(window);